var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-title-divider"},[_c('div',{staticClass:"ll-title-divider__title-line"},[(_vm.title)?_c('p',{staticClass:"ll-title-divider__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"ll-title-divider__subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }